import { StatusTagProps } from "@portal/BaseComponents/Table/Components/StatusTag/StatusTag";
import { FileList } from "@portal/BaseComponents/Upload/type";
import { Files } from "../file";
import { Attachment } from "./attachment";
import { BaseEntity } from "./base-entity";
import { AssociatedInvoice } from "./invoice";
import { SourceApp } from "./source-app";
import { UserUI_DV_DTO } from "./user";

const document_invoice_types = ["ALL", "SELECTIVE"] as const;
export type DOCUMENT_MAPPING_TYPE = (typeof document_invoice_types)[number];
export const DocumentFieldIds = {
  entity_level: "entity_type",
  description: "description",
  invoice_ids: "invoice_ids",
  file_upload_ids: "file_upload_ids",
  type_id: "type_id",
  mapping_type: "mapping_type",
} as const;
const document_sort_col = ["DEFAULT", "CREATED_DATE"] as const;

export type DOCUMENT_FILTER = {
  entity_types: Array<DOCUMENT_ENTITY>;
};
export type DOCUMENT_ENTITY = BaseEntity;
export type DocumentSortCol = (typeof document_sort_col)[number];
export interface DocumentAddedBy extends UserUI_DV_DTO {}
export interface DocumentSharedBy extends UserUI_DV_DTO {}
export type DocumentInvoiceConfig = {
  [DocumentFieldIds.mapping_type]: DOCUMENT_MAPPING_TYPE;
  [DocumentFieldIds.invoice_ids]?: string[];
};

export type CreateDocument = {
  [DocumentFieldIds.entity_level]?: DOCUMENT_ENTITY;
  [DocumentFieldIds.file_upload_ids]: string[];
  [DocumentFieldIds.description]?: string;
  [DocumentFieldIds.type_id]: string;
  [DocumentFieldIds.mapping_type]: DOCUMENT_MAPPING_TYPE;
  [DocumentFieldIds.invoice_ids]: string[];
};
export interface CreateDocumentForm
  extends Omit<CreateDocument, "file_upload_ids"> {
  [DocumentFieldIds.file_upload_ids]: FileList<Files>;
}

export interface DocumentTypes {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  created_by?: DocumentAddedBy;
  updated_by: DocumentAddedBy;
  enabled: boolean;
  description: string;
  entity_type: DOCUMENT_ENTITY;
}
export interface DocumentList {
  id: string;
  description: string;
  created_at: string;
  updated_at: string;
  name: string;
  mapping_type: DOCUMENT_MAPPING_TYPE;
  invoices: AssociatedInvoice[];
  attachment: Attachment;
  type: DocumentTypes;
  entity_type: BaseEntity;
  created_by?: DocumentAddedBy;
  updated_by: DocumentAddedBy;
  shared_by?: DocumentSharedBy;
  source_app: SourceApp;
}

export type DocumentConfigs = {
  [key in BaseEntity]: {
    label: string;
    style: StatusTagProps["style"];
  };
};
